import React from "react";

export function Links({ userParams }) {
  const {
    user: {
      params: { isAdmin }
    },
    changeOrg,
    adminLinks: { adminOrganizations, settings },
    userLinks: { editProfile, changePassword, logout },
    hasSettingsPermission,
    corporateReportingUrl
  } = userParams;

  let changeOrgLink = changeOrg ? (
    <li>
      <a href={changeOrg}>Change Organization</a>
    </li>
  ) : null;

  return (
    <>
      {isAdmin ? (
        <>
          {changeOrgLink}
          <li>
            <a href={adminOrganizations}>Admin Settings</a>
          </li>

          {settings && (
            <li>
              <a href={settings}>Organization Settings</a>
            </li>
          )}
        </>
      ) : (
        <>
          <li>
            <a href={editProfile} target="_blank" rel="noopener noreferrer">
              Profile
            </a>
          </li>
          <li>
            <a href={changePassword}>Change Password</a>
          </li>
          {hasSettingsPermission ? (
            <li>
              <a href={settings}>Organization Settings</a>
            </li>
          ) : null}
          {changeOrgLink}
        </>
      )}
      {corporateReportingUrl ? (
        <li>
          <a href={corporateReportingUrl}>Reporting Portal</a>
        </li>
      ) : null}
      <li>
        <a href={logout}>Log Out</a>
      </li>
    </>
  );
}
